import { render, staticRenderFns } from "./AxCardShadow.vue?vue&type=template&id=1508ac0e&scoped=true"
import script from "./AxCardShadow.vue?vue&type=script&lang=ts"
export * from "./AxCardShadow.vue?vue&type=script&lang=ts"
import style0 from "./AxCardShadow.vue?vue&type=style&index=0&id=1508ac0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1508ac0e",
  null
  
)

export default component.exports